import { render, staticRenderFns } from "./ListadoPagosUniversidades.vue?vue&type=template&id=354b115d"
import script from "./ListadoPagosUniversidades.vue?vue&type=script&lang=js"
export * from "./ListadoPagosUniversidades.vue?vue&type=script&lang=js"
import style0 from "./ListadoPagosUniversidades.vue?vue&type=style&index=0&id=354b115d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports